import * as React from "react";
import { Button, Grid, TextField } from "@mui/material";
import { Formik } from "formik";
import * as Yup from "yup";
import { postNotification } from "../../utils/Notifications";
import { postData } from "../../utils/APIUtilities";

export async function sendVerifyCode(
  username = "",
  setProcessing,
  updateFormType
) {
  if (typeof username != "string" || username.trim() === "") {
    postNotification("error", "Something went wrong");
    return;
  }

  let email = username.trim();

  if (!email) {
    postNotification("error", "Missing required fields");
    return;
  }

  setProcessing(true);

  try {
    await postData("/users/forgotpassword", {
      body: { email },
    });

    postNotification(
      "info",
      "A verification code has been sent to your email. If you do no receive an email within a couple of minutes, please double check the email and if needed contact us to verify your details."
    );

    updateFormType("forgotPasswordSubmit");
  } catch (error) {
    postNotification("error", error, true);
  } finally {
    setProcessing(false);
  }
}

export default function CognitoForgotPasswordForm({
  formState,
  updateFormState,
  updateFormType,
  setProcessing,
}) {
  const onSubmit = async (values) => {
    updateFormState(values);
    await sendVerifyCode(values?.username, setProcessing, updateFormType);
  };

  return (
    <Formik
      initialValues={{
        username: formState?.username || formState?.email || null,
      }}
      enableReinitialize
      validationSchema={Yup.object().shape({
        username: Yup.string().nullable().max(128).required("Required"),
      })}
      onSubmit={onSubmit.bind(this)}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        setFieldValue,
        touched,
        values,
      }) => (
        <form noValidate onSubmit={handleSubmit}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField
                error={Boolean(touched.username && errors.username)}
                helperText={touched.username && errors.username}
                autoComplete="username"
                name="username"
                value={values.username}
                label={"Email"}
                variant="outlined"
                required
                fullWidth
                onBlur={handleBlur}
                onChange={(e) => {
                  const trimmedString = e.target.value.trim().toLowerCase();
                  setFieldValue("username", trimmedString);
                }}
              />
            </Grid>

            <Grid item xs={12}>
              <Button type="submit" fullWidth variant="contained">
                Send Code
              </Button>
            </Grid>
          </Grid>
        </form>
      )}
    </Formik>
  );
}
